



























import MiniAd from './components/mini-ad.vue';
import MiniImgAd from './components/mini-img-ad.vue';
import LargeAd from './components/large-ad.vue';
import { AdType } from '@/types/index';
import { biClick } from '@tencent/fit-bi-sdk';
import { to } from '@tencent/wphk-base-utils';
import { LargeBanner, MiniBanner } from '@/types/home-newest';
import { CustomException } from '@tencent/ppd-base-libs';
import { defineComponent, ref, onMounted, computed } from '@vue/composition-api';
import { getLargeMiniBanner } from './api';
import { useLargeBannerScroll } from './use-large-banner-scroll';

export default defineComponent({
  name: 'LargeMiniBanner',
  components: {
    MiniAd,
    MiniImgAd,
    LargeAd,
  },
  props: {
    hideMiniBanner: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const largeBanner = ref<LargeBanner|null>(null);
    const miniBanner = ref<MiniBanner|null>(null);
    // 是否展示巨幕banner
    const isShowLargeBanner = ref(false);
    // 巨幕banner图片加载是否完成
    const isLargeBannerLoaded = ref(false);
    // 是否展示胶囊banner
    const isShowMiniAd = computed(() => miniBanner.value && !isShowLargeBanner.value);
    // 是否展示胶囊图片banner
    const isMiniImgAd = computed(() => miniBanner.value && miniBanner.value?.type === AdType.img);
    // 是否展示该模块
    const showLargeMiniBannerModule = computed(() => largeBanner.value || miniBanner.value);
    const biExt = computed(() => largeBanner.value?.reportInfo);
    const largeBannerLoaded = function () {
      isLargeBannerLoaded.value = true;
    };
    const { initScrollEvent, cancelScrollEvent, largeMiniBannerCom }  = useLargeBannerScroll();

    const handleLargeBannerClose = function () {
      isShowLargeBanner.value = false;
      cancelScrollEvent();
      emit('largeBannerComplete');
    };

    const showLargeBanner = function () {
      if (largeBanner.value) {
        setTimeout(() => {
          window.scrollTo(0, 0);
          isShowLargeBanner.value = true;
          // 监听触摸滑动
          initScrollEvent(() => {
            handleLargeBannerClose();
            biClick('large-ad.touchend_click|巨幕banner长滑关闭', biExt.value);
          });
        }, 1500);
      }
    };

    onMounted(async () => {
      const [err, largeMiniBannerRes] = await to(getLargeMiniBanner());
      if (err) {
        emit('largeBannerComplete');
        throw new CustomException(err, 'getLargeMiniBannerFail', '获取巨幕banner胶囊banner失败');
      }
      largeBanner.value = largeMiniBannerRes.largeBanner;
      miniBanner.value = largeMiniBannerRes.miniBanner;
      showLargeBanner();
      if (!largeBanner.value) {
        emit('largeBannerComplete');
      }
    });
    return {
      largeBanner,
      miniBanner,
      isShowLargeBanner,
      isLargeBannerLoaded,
      largeMiniBannerCom,
      largeBannerLoaded,
      showLargeMiniBannerModule,
      isShowMiniAd,
      isMiniImgAd,
      handleLargeBannerClose,
    };
  },
});

